module.exports = __webpack_public_path__ + "img/cashier-color.35f28858.png";